import { createContext, ReactNode } from 'react';
import { useRouter } from 'next/router';
import { useImmerReducer } from 'use-immer';

import {
  IPageLayoutDispatch,
  IPageLayoutState,
  pageLayoutReducer,
} from 'layout/state/pageLayoutReducer';

export const PageLayoutStateContext = createContext<IPageLayoutState>(null);
export const PageLayoutDispatchContext = createContext<IPageLayoutDispatch>(null);

interface IPageLayoutProvider {
  children: ReactNode;
}

export const PageLayoutProvider = ({ children }: IPageLayoutProvider) => {
  const { query } = useRouter();
  const isInApp = query?.app === 'y'; // hide the header/footer when deep linking from the apps
  const initialValues = {
    isHeaderVisible: !isInApp,
    isFooterVisible: !isInApp,
    isInApp,
    isMenuVisible: false,
    currentTheme: null,
  };
  const [state, dispatch] = useImmerReducer(pageLayoutReducer, initialValues);

  return (
    <PageLayoutDispatchContext.Provider value={dispatch}>
      <PageLayoutStateContext.Provider value={state}>{children}</PageLayoutStateContext.Provider>
    </PageLayoutDispatchContext.Provider>
  );
};
